export interface ICryoShipmentsPending {
    xmTrackingId: number;
    donorCenter: string;
    donorAlias: string;
    recipientCenter: string;
    recipientAlias: string;
    orderDate: string;
}
